import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Alocação de professores',
    path: '/academico/alocacoes',
    name: 'alocacoes',
    component: () => import('@/views/academico/alocacoes/Index.vue'),
    meta: {
      permissions: [
        eTipoPermissao.ALOCACAODEPROFESSORES_MENU_301000501
      ]
    },
    goesToMenu: true,
  },
  {
    description: 'Cadastro de alocação de professores',
    path: '/academico/alocacoes/cadastro/:id?',
    parent: 'alocacoes',
    name: 'cadastroAlocacoes_create',
    component: () => import('@/views/academico/alocacoes/cadastros/InclusaoEdicao.vue'),
    meta: {
      permissions: [
        eTipoPermissao.ALOCACAODEPROFESSORES_MENU_301000501
      ]
    },
    goesToMenu: false,
  }
];